import React, { useState } from "react";
import poll_symbol from './poll_symbol.png';
import './pollcard.css';
import { Modal } from 'antd';


interface PollCardProps {
    poll: {

        "id": number,
        "question": string,
        "options": [
        {
            "position": number,
            "content": string
        }
        ],
        "winner": null | string
    }
}

const PollCard: React.FC<PollCardProps> = ( { poll }) => {
    const [visible, setVisible] = useState(false);

    let pollStatus

    if(poll.winner) {
        pollStatus = 'closed'
    } else {
        pollStatus = 'active'
    }

    const showModal = () => {
        setVisible(true);
    };

    const handleOk = () => {
    setVisible(false);
    };
    
    const handleCancel = () => {
        setVisible(false);
    };
    

    return(
            <div>
                <div className='poll_card' onClick={showModal}>
                    <div className={`status_info ${pollStatus}`}> 
                        <p>{pollStatus}</p>
                    </div>
                    <div className='poll_card_content'>
                        <img alt='poll_symbol' className='poll_symbol'  src={poll_symbol}/>
                        <div className='card_body'>
                            <p className='question'>{poll.question}</p>
                        </div>
                    </div>
                </div>
                <Modal title={poll.question} visible={visible} onOk={handleOk} onCancel={handleCancel}>
                    {poll.options.map((option, index) => {
                        return <p key={index}>Option {index+1}: {option.content}</p>
                    })}
                    <p>Poll ID: {poll.id}</p>
                    <p>Poll Status: {pollStatus}</p>
                    <p>Winner: {poll.winner? poll.winner: 'No winner yet.'}</p>
                </Modal>
            </div>
    )
};

export default PollCard;